// Glues a block's header + table/bracket content + footer into one page,
// shared by both the single-block "PDF Table" export and each section of
// the combined "Interactive PDF" (TournamentExportModal.js). Mirrors the
// old screenshot pipeline's page-per-block, custom-sized-to-content
// approach - just computed analytically instead of measured off the DOM.
import { getMetricsPdf } from "./pdfFonts";
import { measureHeader, drawHeader, preloadHeaderAssets } from "./pdfHeader";
import { measureFooter, drawFooter } from "./pdfFooter";
import { PDF_RENDERERS } from "./pdfRenderers";

export const MARGIN_MM = 10;

export const preloadBlockAssets = async (kind, tournament, data, grade) => {
    const [{ logoDataUrl }, extra] = await Promise.all([
        preloadHeaderAssets(tournament),
        PDF_RENDERERS[kind].preload(data, grade),
    ]);
    return { logoDataUrl, ...extra };
};

export const measureBlockPage = async (kind, tournament, stageName, data, grade) => {
    const metricsPdf = await getMetricsPdf();
    const contentWidthMm = PDF_RENDERERS[kind].contentWidthMm(data);
    const headerH = measureHeader(metricsPdf, tournament, stageName, contentWidthMm).heightMm;
    const blockH = PDF_RENDERERS[kind].measure(data, grade);
    const footerH = measureFooter();
    return { contentWidthMm, contentHeightMm: headerH + blockH + footerH };
};

export const drawBlockPage = (pdf, x, y, kind, tournament, stageName, data, grade, i18n, contentWidthMm, assets) => {
    let cy = drawHeader(pdf, x, y, tournament, stageName, contentWidthMm, assets.logoDataUrl);
    cy = PDF_RENDERERS[kind].draw(pdf, x, cy, data, grade, i18n, assets);
    cy = drawFooter(pdf, x, cy, contentWidthMm);
    return cy;
};
